module.exports = " <div class=imgBox> <div class=loading> <i class=\"fa fa-spinner\" aria-hidden=true></i> <span>全速加载中。。。。。</span> </div> <div class=photos> <nav> <a v-link=\"{name: 'Dashboard', exact: true}\"> <img src=" + require("../assets/logo.png") + " alt=首页 /> </a> </nav> </div> <div class=down> <nav> <a v-bind:href=downloads> 下载 </a> </nav> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/vue-html-loader/1.2.3/vue-html-loader!./~/.npminstall/vue-loader/8.5.3/vue-loader/lib/selector.js?type=template&index=0!./src/views/PhotoDetail.vue
 ** module id = 83
 ** module chunks = 0
 **/